<template lang="pug">
	#app
		appBanner(v-if="withBanner && !desk")
		block-header
		router-view
		block-footer
</template>

<script>

import {mapState} from "vuex";
import BlockHeader from "@/blocks/includes/header";
import BlockFooter from "@/blocks/includes/footer";
import appBanner from "@/components/appBanner";

export default {
	name: 'appComponent',
	components: {
		appBanner,
		BlockHeader,
		BlockFooter,
	},
	updated() {
		if (!this.desk) {
			if (this.getCookie('showBanner')) {
				document.getElementById('app').style.paddingTop = '50px';
			} else {
				document.getElementById('app').style.paddingTop = '111px';
			}
		} else {
			document.getElementById('app').style.paddingTop = '0px';
		}
	},
	computed: {
		...mapState([
			'withBanner',
			'desk',
		]),
	},
	methods: {
		getCookie(name) {
			const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
			return v ? v[2] : null;
		},
	},
}

</script>

<style lang="scss" scoped>

</style>
